// mparle-collection-load-more.js
// AJAX-append voor de "Toon meer" knop op collectie-pagina's. Bij klik:
// fetch de volgende pagina, parse hem, append de cards aan de bestaande grid
// en vervang de knop door de nieuwe (of verwijder hem als er geen next is).
// No-JS fallback: de knop is een echte <a href> die normaal naar de next-page navigeert.
(function () {
  const grid = document.querySelector('[data-mp-grid]');
  let wrap = document.querySelector('[data-mp-load-more-wrap]');
  if (!grid || !wrap) return;

  let busy = false;

  async function loadMore(btn) {
    if (busy) return;
    const url = btn.dataset.mpNextUrl;
    if (!url) return;
    busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`load-more ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-mp-grid]');
      const newWrap = doc.querySelector('[data-mp-load-more-wrap]');
      if (!newGrid) return;

      const fragment = document.createDocumentFragment();
      while (newGrid.firstChild) fragment.appendChild(newGrid.firstChild);
      grid.appendChild(fragment);

      if (newWrap) {
        wrap.replaceWith(newWrap);
        wrap = newWrap;
        const nextBtn = newWrap.querySelector('[data-mp-load-more]');
        if (nextBtn) attach(nextBtn);
      } else {
        wrap.remove();
      }
    } catch (err) {
      console.error('mp load-more failed', err);
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      busy = false;
      return;
    }
    busy = false;
  }

  function attach(btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      loadMore(btn);
    });
  }

  const initial = wrap.querySelector('[data-mp-load-more]');
  if (initial) attach(initial);
})();
